module.exports = __webpack_public_path__ + "img/icon-logout.322c4feb.svg";